module.exports = __webpack_public_path__ + "static/media/pepper1.9ec2bc47.png";